import React ,{ Fragment, useRef, useEffect} from 'react'
//import { Document, Page, pdfjs } from 'react-pdf';
// import testPDF from "./assets/SWP_231-01.pdf"
//import {saveAnnoations, getAnnoations} from "./util/mapping_util";
import WebViewer from '@pdftron/webviewer'
import {deleteHighlight} from "../../../../../util/wi_util"

//import './App.css';

//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function PDFDisplay({setSelectedText,setPdfViewerInstance,
                                    textToSearch,currentPDF,setMappingAnnotations,
                                    getCameraInfo,addNewHighlightAnnotation,
                                    PDFViewerHighlights,deletePDFAnnotation,toggleAttachments,
                                    setSelectedAnnotation,updateAnnoList,isRedraw,deleteSingleAnnotation,
                                    setWILinkModal,openNewTab, isLiteView}){
    const viewerDiv = useRef(null);

    useEffect(()=>{
      WebViewer({
        path:'lib', 
        initialDoc:currentPDF
      }, viewerDiv.current).then(instance => {
          const {docViewer, Annotations } = instance;
          const annoManager = docViewer.getAnnotationManager();
          //instance.UI.disableElements(['ribbons']);
          //////////////////////////DISABLES THE TOP RIBBON OF TOOLS
           instance.UI.disableElements(['toolbarGroup-Shapes']);
         // instance.UI.disableElements(['toolbarGroup-Edit']);
           instance.UI.disableElements(['toolbarGroup-Insert']);
           instance.UI.disableElements(['toolbarGroup-Annotate']);
           instance.UI.disableElements(['toolbarGroup-Forms']);
           instance.UI.disableElements(['toolbarGroup-FillAndSign']);
          //instance.UI.disableElements(['toolbarGroup-View']);

           //instance.UI.setToolbarGroup(['toolbarGroup-View']);
           //instance.UI.disableElements(['cropToolGroupButton']);
          instance.UI.disableElements(['menuButton']);
          instance.UI.disableElements(['toggleNotesButton']);
          instance.UI.disableElements(['panToolButton']);
          instance.UI.disableElements(['viewControlsButton']);
          instance.UI.disableElements(['selectToolButton']);
          /////////////////DISABLES THE RIBBON WHEN MAKING A SELECTION
          instance.UI.disableElements(['annotationCommentButton']);
          instance.UI.disableElements(['textUnderlineToolButton']);
          instance.UI.disableElements(['textSquigglyToolButton']);
          instance.UI.disableElements(['textStrikeoutToolButton']);
          instance.UI.disableElements(['annotationStyleEditButton']);
          //instance.UI.disableElements(['copyTextButton']);
          console.log("idadadaasLiteView",isLiteView)
          if (!isLiteView){

            instance.UI.updateElement("textHighlightToolButton", {title:"Save Highlight", onClick: () =>{console.log('clicked');addNewHighlightAnnotation()} });
            instance.UI.updateElement("annotationDeleteButton", { onClick: () =>{
              deleteSingleAnnotation()
            }});
            instance.UI.disableElements(['copyTextButton']);
  
  
            
            docViewer.addEventListener('textSelected', (quads, selectedText, pageNumber) => {
              //  console.log(selectedText);
               // console.log(quads)
               
               instance.UI.enableElements(['toggleNotesButton'])
               instance.UI.enableElements(['linkButton'])
               instance.UI.disableElement(['textUnderlineToolButton'])
               instance.UI.updateElement("linkButton", { title:"Link Work Instruction", onClick: () =>{setWILinkModal(true)}});
                setSelectedText(selectedText,quads,pageNumber)
            });
          }else{
            instance.UI.disableElement()
            instance.UI.disableElement("textHighlightToolButton")
            instance.UI.disableElement("annotationDeleteButton")
            instance.UI.disableElement("copyTextButton")
            instance.UI.enableElements(['toggleNotesButton'])
            instance.UI.disableElement(['linkButton'])
            instance.UI.disableElement(['textUnderlineToolButton'])
          }          
       
          setPdfViewerInstance(instance,docViewer, Annotations,annoManager);

          annoManager.addEventListener('annotationSelected', (annotations, action) => {
            if (action === 'selected') {
              console.dir(annotations)
              if(annotations[0].elementName.includes("~~~~WILINK:")){
                let splitname = annotations[0].elementName.split("~~~~WILINK:")
                let wiInfo = JSON.parse(splitname[1])
                instance.UI.disableElement(['toggleNotesButton'])
                
                if (!isLiteView) {
                  // Full edit mode: allow opening WI and deleting the link
                  instance.UI.enableElements(['linkButton'])
                  instance.UI.updateElement("annotationDeleteButton", { onClick: () =>{
                      deleteSingleAnnotation(wiInfo.wip_ID)
                  }});
                  instance.UI.updateElement("linkButton", { title:"Open Work Instruction", onClick: () =>{openNewTab(wiInfo.title,wiInfo.wip_ID)}}); 
                } else {
                  // Lite view (read-only): allow opening WI but not deleting
                  instance.UI.enableElements(['linkButton'])
                  instance.UI.disableElement(['annotationDeleteButton'])
                  instance.UI.updateElement("linkButton", { title:"Open Work Instruction", onClick: () =>{openNewTab(wiInfo.title,wiInfo.wip_ID)}}); 
                }
                setSelectedAnnotation(annotations[0],annotations[0].Quads[0])

              }
              else{
                instance.UI.disableElements(['linkButton'])
                if (!isLiteView) {
                  instance.UI.enableElements(['linkButton'])
                  instance.UI.updateElement("annotationDeleteButton", { onClick: () =>{
                      deleteSingleAnnotation()
                      
                  }});
                  instance.UI.updateElement("linkButton", {title: 'Link Attachment', onClick: () => {console.log(' toggleAttachments clicked');toggleAttachments()}});
                }
                //instance.UI.updateElement("annotationCommentButton", {title:"Link Work Instruction",onClick: () =>{setWILinkModal(true)}});                                                                                                                                                                                                                             
                console.log(annotations[0])
                setSelectedAnnotation(annotations[0],annotations[0].Quads[0])
                  }
            }
          });
        
          docViewer.on('documentLoaded', async ()=>{
            // getCameraInfo()
           let data =  PDFViewerHighlights
          //  console.log('TEST', anno.Anno_id)
           updateAnnoList(data)
             if (data != null && data.length > 0){
              // setMappingAnnotations(data)
                data.forEach(anno => {
                  const highlight = new Annotations.TextHighlightAnnotation();
                  highlight.PageNumber = anno.pageNumber; 
                  if (anno.Anno_id.includes("~~~~WILINK:")){
                    highlight.StrokeColor = new Annotations.Color(144,238,144);
                  } 
                  else{
                    highlight.StrokeColor = new Annotations.Color(255, 255, 0);
                  }              
                  
                  // you might get the quads from text selection, a server calculation, etc
                  highlight.Quads = anno.quads
                  highlight.elementName = anno.Anno_id
                  annoManager.addAnnotation(highlight);
                  annoManager.drawAnnotations(highlight.PageNumber);
                });
             
             }
          

           });
      });
    },[]);


      return(<Fragment>
        <div className="App2" style={{width:"100%",height:"100%", overflow:"hidden"}}>
          <div className="webviewer" style={{height:"100%"}} ref={viewerDiv}></div>
        </div>
  </Fragment>
      );

}
